// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import APIS from '@/apis'

Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.APIS = APIS

axios.interceptors.request.use((config) => {
  // 请求拦截
  if (config.url.startsWith('/drinks')) {
    const local = localStorage.getItem('userInfo')
        const token = JSON.parse(local).token ? JSON.parse(local).token : ''
    if (token && !config.headers['Authorization']) {
          config.headers['Authorization'] = `Bearer ${token}` // 让每个请求携带自定义 token 请根据实际情况自行修改 plugin的Authorization 在api处各自添加
      }
  }

  return config
})
axios.interceptors.response.use((response) => {
  // 返回拦截
  if (response.config.url.startsWith('/drinks')) {
    if (response && response.data.code === 202) {
     router.push({ path: '/p/login' })
    }
    if (response && response.data) {
      return response.data
    }
  }
  return response
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js